import React, { Component } from 'react';
import '../css/App.css';
import '../css/animations.css';
import SVG  from 'react-inlinesvg';
import Carousel3D from 'react-carousel-3d';
import BinaryBackground from '../components/BinaryBackground';
import {detect} from 'detect-browser'

const browser = detect().name

export default class App extends Component {

  constructor(props) {
    super(props);
  
    this.state = {
      windowHeight: 0,
      windowWidth: 0,
      scrollY: 0,
    };

    this.lastScrollUpdate = Date.now()

    this.webScreenshot = require('../img/dinesafe-web.png')
    this.appWelcomeScreenshot = require('../img/dinesafe-app-welcome.png')
    this.appUserScreenshot = require('../img/dinesafe-app-user.png')
    this.appEditMealScreenshot = require('../img/dinesafe-app-edit-meal.png')
    this.appRestaurantAccountScreenshot = require('../img/dinesafe-app-restaurant-account.png')
    this.appMiscScreenshot = require('../img/dinesafe-app-misc.png')
  }

  componentWillMount() {
    this.updateDimensions();
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this))
    window.addEventListener('scroll', this.onScroll.bind(this))
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
    window.removeEventListener('scroll', this.onScroll.bind(this))
  }

  updateDimensions() {
    this.setState({windowHeight: browser == 'ios' ? window.screen.height : window.innerHeight, windowWidth: window.innerWidth})
  }
  onScroll() {

    const date = Date.now()
    if (date - this.lastScrollUpdate > 30) {
      this.lastScrollUpdate = date
      this.setState({scrollY: window.pageYOffset})
    }
  }

  render() {

    return (
      <div style={styles.mainContainer}>
        {this.Intro()}
        {this.IntroOverlay()}
        {this.Spacer()}
        {this.SectionTitle('About Me', this.aboutContainer && this.aboutContainer.offsetTop || 0)}
        {this.About()}
        {this.SectionTitle('Recent Projects', this.minerBotContainer && this.minerBotContainer.offsetTop || 0)}
        {this.MinerBot()}
        {this.DineSafe()}
        {this.DineSafeScreenshots()}
        
        <div style={{textAlign: 'center', padding: 100}}>
          <h2 className='title glow'>More Coming Soon</h2>
          <h2 className='subtitle'>This site is a work in progress.</h2>
          <div className='title-underline' />
        </div>
      </div>
    );
  }



  Intro() {

    if (this.state.scrollY > this.state.windowHeight) return null

    const scale = 1 + this.state.scrollY / this.state.windowHeight / 4

    return (
      <div style={{...styles.introContainer, height: this.state.windowHeight, transform: `scale(${scale})`}}>
        <h1 className='title'>Hi, I'm <span className='glow'>David</span></h1>
        <h2 className='subtitle'>Freelance Mobile & Web Developer - <span style={{color: '#FF5454'}}>Ormond Beach, FL</span></h2>
        <div className='title-underline' />
      </div>
    )
  }


  IntroOverlay() {

    const opacity = this.state.scrollY / this.state.windowHeight

    return (
      <div style={{...styles.introOverlay, opacity: opacity}}></div>
    )
  }


  Spacer() {

    return (
      <div style={{opacity: 0, height: this.state.windowHeight * 2.25}}></div>
    )
  }


  SectionTitle(text, height) {

    const shouldMove = this.state.scrollY < height && this.state.scrollY > height - this.state.windowHeight * 1.9

    const top = -(height - 100 - this.state.scrollY) / 5

    return (
      <div style={{textAlign: 'center', paddingBottom: 60, transform: shouldMove ? `translateY(${top}px)` : ''}}>
        <h2 className='title glow'>{text}</h2>
        <div className='title-underline' />
      </div>
    )
  }


  About() {

    return (
      <div ref={div => this.aboutContainer = div} style={{margin: 'auto', paddingLeft: 30, paddingRight: 30, paddingBottom: 300, maxWidth: 1000, textAlign: 'justify'}}>
        <p>Born in Miami, Florida but raised in Fairbanks, Alaska. After I graduated high school, I attended the University of Alaska Fairbanks in pursuit of a Civil Engineering degree. Two years in, I took an opportunity to leave Alaska and move to Central Florida. I quickly started a business repairing smartphones and durning my down time I started to learn how to write code.</p>
        <br />
        <p>I started with Unity and built a few games, but I eventually moved on to building apps and websites. At some point I gave React a try and immediatly loved the declarative nature of it.</p>
        <br />
        <p>My passion is creating intuitive and unique user experiences. I created this site with the goal to experiment with and refine my skills in WebGL, CSS Grid, CSS Animations, and CSS 3D Transforms. The only frameworks/libraries used are <a href='https://github.com/facebook/react/' target='_blank'>ReactJS</a>, <a href='https://github.com/pixijs/pixi.js/' target='_blank'>PixiJS</a>, and <a href='https://github.com/styled-components/styled-components' target='_blank'>Styled-Components</a>.</p>
      </div>
    )
  }


  MinerBot() {

    return (
      <div ref={div => this.minerBotContainer = div} className='project-container miner-bot'>
        
        <div className='binary-bg-container'>
          <BinaryBackground color='#A8BEFF' />
        </div>

        <div className='miner-bot-text-container'>
          <h2 className='project-title'>Bitcoin Mining Bot</h2>
          <br/>
          <div style={{textAlign: 'justify'}}>
            <p>I developed a bot that leverages the API of hashing power rental site <a href='https://www.nicehash.com'>NiceHash</a> and a Bitcoin mining pool. The plan was to monitor the cost of hashing power and purchase it when it was most profitable.</p>
            <br/>
            <p>Small gains turned into larger gains as I spent more time refining the algorithm. Throughout its lifetime, it has mined approximately <a href='/img/mining-pool-screenshot.png'>89 Bitcoins</a> with a profit of 8.25 Bitcoins.</p>
            <br/>
            <p>My next project in this space will be something more fitting to the ideology of a decentralized and distributed world, instead of a purely monetarily focused project. More on this later.</p>
          </div>

        </div>
        {this.MinerBotAnimation()}
      </div>
    )
  }


  MinerBotAnimation() {

    const windowWidth = this.state.windowWidth
    const scale = 1 - 250/windowWidth

    return (
      <div className='miner-bot-animation-container'>
        <div style={{position: 'relative', transform: `scale(${scale},${scale})`, minHeight: 400}}>
          <div style={{position: 'absolute', width: 200, height: 200, top: -50, left: -250}}>
            <SVG className='stone' src={require("../img/stone.svg")} />
            <SVG className='pickaxe' src={require("../img/pickaxe.svg")} />
            <SVG className='bitcoin' src={require("../img/bitcoin.svg")} />
            <div className='debris-container'>
              <div className='debris one' />
              <div className='debris two' />
              <div className='debris three' />
              <div className='debris four' />
              <div className='debris five' />
            </div>
          </div>
          <div style={{position: 'absolute', width: 330, height: 330, top: 50, left: -250}}>
            <SVG className='stone' src={require("../img/stone.svg")} />
            <SVG className='pickaxe' src={require("../img/pickaxe.svg")} />
            <SVG className='bitcoin' src={require("../img/bitcoin.svg")} />
            <div className='debris-container'>
              <div className='debris one' />
              <div className='debris two' />
              <div className='debris three' />
              <div className='debris four' />
              <div className='debris five' />
            </div>
          </div>
          <div style={{position: 'absolute', width: 270, height: 270, top: -50, left: -20, zIndex:-1}}>
            <SVG className='stone' src={require("../img/stone.svg")} />
            <SVG className='pickaxe' src={require("../img/pickaxe.svg")} />
            <SVG className='bitcoin' src={require("../img/bitcoin.svg")} />
            <div className='debris-container'>
              <div className='debris one' />
              <div className='debris two' />
              <div className='debris three' />
              <div className='debris four' />
              <div className='debris five' />
            </div>
          </div>
        </div>
      </div>
    )
  }


  DineSafe() {

    return (
      <div className='project-container dinesafe' ref={div => this.dinesafeContainer = div}>
        <div className='dinesafe-logo-container'>
          <img className='dinesafe-image' src={require('../img/dinesafe-logo.png')} />
          <h2 className='dinesafe-text'>Dine<span style={{fontWeight:700}}>Safe</span></h2>
        </div>
        <div className='description-container'>
          <p style={{opacity: 1,  color: 'white'}}>DineSafe is a platform for restaurants to manage and provide allergen and nutritional information to their customers. The customer facing app sorts a restaurant's menu items based on the their restrictions.</p>
          <p style={{opacity: 1, color: 'white', paddingTop: 20}}>I was the sole developer and also had the responsibilities of restaurant, user, and press outreach. I served a key role in fostering a partnership with an international restaurant franchise.</p>
        </div>
        <div className='tech-used-container'>
          <div className='tech-1'>
            <div className='tech-icon-container'>
              <SVG className='tech-icon phone' src={require("../img/smart-phone.svg")} />
            </div>
            <p className='list-bubble'>React Native</p>
            <p className='list-bubble'>ES6</p>
            <p className='list-bubble'>Redux</p>
            <p className='list-bubble'>Bug Snag</p>
          </div>
          <div className='tech-2'>
            <div className='tech-icon-container'>
              <SVG className='tech-icon desktop' src={require("../img/desktop.svg")} />
            </div>
            <p className='list-bubble'>ReactJS</p>
            <p className='list-bubble'>ES6</p>
            <p className='list-bubble'>Redux</p>

          </div>
          <div className='tech-3'>
            <div className='tech-icon-container'>
              <SVG className='tech-icon server' src={require("../img/server.svg")} />
            </div>
            <p className='list-bubble'>NodeJS</p>
            <p className='list-bubble'>MongoDB</p>
            <p className='list-bubble'>Parse Server</p>

          </div>
        </div>
      </div>
    )
  }


  DineSafeScreenshots() {

    return (
      <Carousel3D backgroundColor='rgba(255,255,255,0.1)' elements={[
        <img className='dinesafe-web-screenshot' src={this.webScreenshot} />,
        <img className='dinesafe-web-screenshot' src={this.appWelcomeScreenshot} />,
        <img className='dinesafe-web-screenshot' src={this.appUserScreenshot} />,
        <img className='dinesafe-web-screenshot' src={this.appEditMealScreenshot} />,
        <img className='dinesafe-web-screenshot' src={this.appRestaurantAccountScreenshot} />,
        <img className='dinesafe-web-screenshot' src={this.appMiscScreenshot} />,
      ]} />
    )
  }
}



  const styles = {
    mainContainer: {
      backgroundColor: 'transparent',
      overflowX: 'hidden',

    },
    introContainer: {
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: -2,
      paddingLeft: 40,
      paddingRight: 40,
      textAlign: 'center',
    },
    introOverlay: {
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: '#070912',
      zIndex: -1,
    },
    pickaxe: {
      width: 100,
      height: 100,
    }
  }



// WEBPACK FOOTER //
// ./src/screens/Home.js